import React from 'react';

import { CreditCard } from './creditcard.component';

interface ContinueToReviewProps {
    setCheckoutStep: (string) => void;
}

export const CreatePayment = ({ setCheckoutStep }: ContinueToReviewProps) => {
    return (
        <div style={{ marginTop: '10px' }} className="create-payment__wrap">
            <CreditCard
                setCheckoutStep={setCheckoutStep}
                selectedCreditCard={null}
                setAddModalIsOpen={null}
                setEditModalIsOpen={null}
                setOpenParentModal={null}
                showPayPal={true}
            />
        </div>
    );
};
